const UgandaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112665)">
      <path
        d="M34.9057 33.3327C38.0731 29.7942 40 25.1222 40 19.9994C40 14.8766 38.073 10.2045 34.9056 6.66602L20 5.2168L5.09438 6.66602C1.92695 10.2045 0 14.8766 0 19.9994C0 25.1222 1.92688 29.7942 5.0943 33.3327L20 34.782L34.9057 33.3327Z"
        fill="#FFDA44"
      />
      <path
        d="M5.09424 6.66664H34.9056C31.2435 2.57547 25.9228 0 19.9999 0C14.077 0 8.75627 2.57547 5.09424 6.66664Z"
        fill="black"
      />
      <path
        d="M0 19.9997L20 21.7389L40 19.9997C40 17.6619 39.5976 15.4183 38.8603 13.333H1.13969C0.402422 15.4183 0 17.6619 0 19.9997H0Z"
        fill="#D80027"
      />
      <path
        d="M1.13969 26.6666H38.8605C39.5976 24.5813 40 22.3378 40 20H0C0 22.3378 0.402422 24.5813 1.13969 26.6666Z"
        fill="black"
      />
      <path
        d="M34.9056 33.333H5.09424C8.75627 37.4243 14.077 39.9997 19.9999 39.9997C25.9229 39.9997 31.2436 37.4243 34.9056 33.333Z"
        fill="#D80027"
      />
      <path
        d="M26.6745 19.9991C26.6745 23.6853 23.6867 26.673 20.0006 26.673C16.3144 26.673 13.3267 23.6853 13.3267 19.9991C13.3267 16.3129 16.3144 13.3252 20.0006 13.3252C23.6867 13.3252 26.6745 16.3129 26.6745 19.9991Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.4448 20.3407L19.9998 19.2812C19.9998 19.2812 20.5719 17.3826 20.6023 17.2527C20.6246 17.1577 20.6365 17.0587 20.6365 16.957C20.6365 16.5968 20.4905 16.2707 20.2544 16.0348L20.8692 15.4199C20.4759 15.0266 19.9323 14.7832 19.332 14.7832C18.7317 14.7832 18.1882 15.0265 17.7948 15.4199L18.4097 16.0348C18.1736 16.2708 18.0277 16.5969 18.0277 16.957C18.0277 17.0887 18.0476 17.2157 18.0839 17.3356L17.1582 18.2612H18.8407C18.8407 18.2612 18.1451 19.3061 17.7653 20.1641C17.3855 21.0221 17.7705 22.0695 18.6482 22.4597L19.1557 22.6852L19.9998 23.4787V24.3482L19.1303 25.2177H20.8695V23.4786L21.663 22.6851H23.3042C23.3121 22.6688 23.3204 22.6528 23.3279 22.6361C23.7178 21.7585 23.3225 20.7307 22.4448 20.3407Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112665">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default UgandaSvg;
